/**
 * Admin Controls Tab Component
 * 
 * Centralized view for all trading kill switches and controls.
 * Embeds AdminTradingPipelineTab to keep Kill switches unchanged.
 */

import { AdminTradingPipelineTab } from "@app/features/admin-trading-pipeline/AdminTradingPipelineTab";
import "./admin-controls.css";

export function AdminControlsTab(): JSX.Element {
  return (
    <div className="admin-controls-root">
      <AdminTradingPipelineTab />
    </div>
  );
}

